import PropTypes from 'prop-types';
import React from 'react';

import CloseIcon, { SIZES } from 'components/CloseIcon';
import IconButton from 'components/IconButton';
import VideoPlayer from 'components/VideoPlayer';
import Theme from 'styles/theme';

const SecondaryPromoHeroInlineVideoPlayer = ({ videoUrl, onClose, ...otherProps }) => (
  <div className="HomepageV2SecondaryPromoHero__inline-video-player">
    <VideoPlayer url={videoUrl} playing playsinline controls onEnded={onClose} {...otherProps} />
    <div className="HomepageV2SecondaryPromoHero__video-close-button">
      <IconButton onClick={onClose}>
        <CloseIcon size={SIZES.LARGE} />
      </IconButton>
    </div>
    <style jsx>
      {`
        .HomepageV2SecondaryPromoHero__inline-video-player {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: black;
        }

        .HomepageV2SecondaryPromoHero__video-close-button {
          position: absolute;
          top: ${Theme.get('spacing') * 3}px;
          right: ${Theme.get('spacing') * 3}px;
        }
      `}
    </style>
    <style jsx global>
      {`
        .HomepageV2SecondaryPromoHero__inline-video-player div.VideoPlayer {
          padding-top: 0;
          width: 100%;
          height: 100%;
        }

        .HomepageV2SecondaryPromoHero__inline-video-player video {
          outline: none;
        }

        .HomepageV2SecondaryPromoHero__inline-video-player .CloseIcon:before,
        .HomepageV2SecondaryPromoHero__inline-video-player .CloseIcon:after {
          background-color: ${Theme.get('colors-white')};
        }
      `}
    </style>
  </div>
);

SecondaryPromoHeroInlineVideoPlayer.propTypes = {
  videoUrl: PropTypes.string,
  onClose: PropTypes.func,
};

SecondaryPromoHeroInlineVideoPlayer.defaultProps = {
  videoUrl: '',
  onClose: () => {},
};

export default SecondaryPromoHeroInlineVideoPlayer;
